import React from 'react';
import { Button, ButtonProps } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface CreateButtonProps extends Omit<ButtonProps, 'onClick'> {
  route: string;
  label?: string;
  className?: string;
  customHandler?: () => void;
}

const CreateButton: React.FC<CreateButtonProps> = ({
  route,
  label = 'common.create',
  className = 'd-flex justify-content-end',
  customHandler,
  ...buttonProps
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    if (customHandler) {
      customHandler();
    } else {
      navigate(route);
    }
  };

  return (
    <div className={className}>
      <Button
        type="primary"
        size="large"
        icon={<PlusOutlined />}
        onClick={handleClick}
        {...buttonProps}
      >
        {t(label)}
      </Button>
    </div>
  );
};

export default CreateButton;
